import React from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { Button } from '@eika/button';
import { RichIconTypes } from '@eika/rich-icon';

import { Content } from '../../components/shared/Content';
import { ErrorCardWrapper } from '../../components/shared/ErrorCardWrapper';
import useTranslation from '../../hooks/useTranslation';

interface Props {
    error: RequestExceptionWithResponse;
    refetch: () => void;
}

export default ({ error, refetch }: Props) => {
    const translated = useTranslation();
    if (error.errorName === 'DIRECT_DEBIT_CLIENT_DOES_NOT_HAVE_ACCESS') {
        return (
            <Content>
                <ErrorCardWrapper exception={error} iconType={RichIconTypes.HAAND_HEIHEI} hideErrorCode />
            </Content>
        );
    }
    return (
        <Content>
            <ErrorCardWrapper exception={error}>
                <Button onClick={() => refetch()}>{translated.tryAgain}</Button>
            </ErrorCardWrapper>
        </Content>
    );
};
